;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import PropTypes from 'prop-types';

import Img from 'components/ui/Img';
import Link from 'components/ui/Link';
import Text from 'components/ui/Text';

import styles from './CardStory.module.scss';

const CardStory = ({ title, category, slug, cardImage }) => {
    return (
        <li className={styles.listItem}>
            <Link href={`/news/${slug}`}>
                <figure className={styles.aspectBox}>
                    {cardImage?.url && (
                        <Img
                            className={styles.image}
                            src={cardImage.url}
                            width={cardImage?.width}
                            height={cardImage?.height}
                            fallbackImageWidth={1030}
                            alt={cardImage.description || ''}
                            customSources={[
                                {
                                    breakpoint: 768,
                                    src: cardImage.url,
                                    imageWidth: 1030,
                                },
                                {
                                    src: cardImage.url,
                                    imageWidth: 768,
                                },
                            ]}
                        />
                    )}
                </figure>
                <figcaption className={styles.textBlock}>
                    <Text
                        baseTheme="labelSmall"
                        themes={{ medium: 'labelLarge' }}
                        className={styles.storySubHeadline}
                        as="p"
                    >
                        {category}
                    </Text>
                    <div className={styles.storyHeadlineWrapper}>
                        <Text
                            baseTheme="headingSmall"
                            themes={{ medium: 'headingLarge' }}
                            className={styles.storyHeadline}
                            as="h3"
                        >
                            {title}
                        </Text>
                    </div>
                    <Text
                        baseTheme="bodySmall"
                        themes={{ medium: 'bodyMedium' }}
                        className={styles.link}
                        as="p"
                    >
                        View Story →
                    </Text>
                </figcaption>
            </Link>
        </li>
    );
};

CardStory.propTypes = {
    cardImage: PropTypes.shape({
        description: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number,
        url: PropTypes.string,
    }),
    category: PropTypes.string,
    slug: PropTypes.string,
    title: PropTypes.string.isRequired,
};

export default CardStory;
